export const HorseStatisticsMockData = {
    name: "TWIN PEAKS",
    horseDetails: "3 BF - DOB: 01.10.2013 Geld: 23.02.15",
    sponsor: 'PATH FORK - World perfect by National Assembly',
    breeder: 'Breeder: Mr S E BENNETT',
    owners: 'MR R B Bradley & Mr & Mrs A C Greeff',
    totalRuns: '30:3-6-4',
    stakes: 'R254575',
    salePrice: 'R80 000',
    course: '10:2-0-2',
    distance: '7:2-0-0',
    courseAndDistance: '2:1-0-1',
    poly: '0:0-0-0',
    wet: '10:2-4-0',
    sand:'0:0-0-0',
    previousRuns: [
        {
            date: '21.03.18',
            course: 'F',
            referenceAndGoing: '328G',
            race: 'JP-F',
            averageFieldRating: '61',
            equipment: 'A',
            distance: '1200m',
            meritRating: '63',
            draw: '3/12',
            position: {
                value: '1',
                raceId: ''
            },
            lengthsBehind: '1,25',
            winnerOrSecond: {
                name: 'Sultry 53kg',
                horseId: ''
            },
            jockey: {
                name: 'Mjoka M',
                jockeyId: ''
            },
            weight: '51,5kg',
            time: '102,94',
            adjustedTime: '104,67',
            openingPrice: {
                numerator: '8',
                denominator: '1'
            },
            startingPrice: {
                numerator: '13',
                denominator: '1'
            },
            comment: 'Ran on well'
        },
        {
            date: '21.03.18',
            course: 'F',
            referenceAndGoing: '328G',
            race: 'JP-F',
            averageFieldRating: '61',
            equipment: 'A',
            distance: '1200m',
            meritRating: '63',
            draw: '3/12',
            position: {
                value: '1',
                raceId: ''
            },
            lengthsBehind: '1,25',
            winnerOrSecond: {
                name: 'Sultry 53kg',
                horseId: ''
            },
            jockey: {
                name: 'Mjoka M',
                jockeyId: ''
            },
            weight: '51,5kg',
            time: '102,94',
            adjustedTime: '104,67',
            openingPrice: {
                numerator: '8',
                denominator: '1'
            },
            startingPrice: {
                numerator: '13',
                denominator: '1'
            },
            comment: 'Ran on well'
        },
        {
            date: '21.03.18',
            course: 'F',
            referenceAndGoing: '328G',
            race: 'JP-F',
            averageFieldRating: '61',
            equipment: 'A',
            distance: '1200m',
            meritRating: '63',
            draw: '3/12',
            position: {
                value: '1',
                raceId: ''
            },
            lengthsBehind: '1,25',
            winnerOrSecond: {
                name: 'Sultry 53kg',
                horseId: ''
            },
            jockey: {
                name: 'Mjoka M',
                jockeyId: ''
            },
            weight: '51,5kg',
            time: '102,94',
            adjustedTime: '104,67',
            openingPrice: {
                numerator: '8',
                denominator: '1'
            },
            startingPrice: {
                numerator: '13',
                denominator: '1'
            },
            comment: 'Ran on well'
        },
        {
            date: '21.03.18',
            course: 'F',
            referenceAndGoing: '328G',
            race: 'JP-F',
            averageFieldRating: '61',
            equipment: 'A',
            distance: '1200m',
            meritRating: '63',
            draw: '3/12',
            position: {
                value: '1',
                raceId: ''
            },
            lengthsBehind: '1,25',
            winnerOrSecond: {
                name: 'Sultry 53kg',
                horseId: ''
            },
            jockey: {
                name: 'Mjoka M',
                jockeyId: ''
            },
            weight: '51,5kg',
            time: '102,94',
            adjustedTime: '104,67',
            openingPrice: {
                numerator: '8',
                denominator: '1'
            },
            startingPrice: {
                numerator: '13',
                denominator: '1'
            },
            comment: 'Ran on well'
        },
        {
            date: '21.03.18',
            course: 'F',
            referenceAndGoing: '328G',
            race: 'JP-F',
            averageFieldRating: '61',
            equipment: 'A',
            distance: '1200m',
            meritRating: '63',
            draw: '3/12',
            position: {
                value: '1',
                raceId: ''
            },
            lengthsBehind: '1,25',
            winnerOrSecond: {
                name: 'Sultry 53kg',
                horseId: ''
            },
            jockey: {
                name: 'Mjoka M',
                jockeyId: ''
            },
            weight: '51,5kg',
            time: '102,94',
            adjustedTime: '104,67',
            openingPrice: {
                numerator: '8',
                denominator: '1'
            },
            startingPrice: {
                numerator: '13',
                denominator: '1'
            },
            comment: 'Ran on well'
        },
        {
            date: '21.03.18',
            course: 'F',
            referenceAndGoing: '328G',
            race: 'JP-F',
            averageFieldRating: '61',
            equipment: 'A',
            distance: '1200m',
            meritRating: '63',
            draw: '3/12',
            position: {
                value: '1',
                raceId: ''
            },
            lengthsBehind: '1,25',
            winnerOrSecond: {
                name: 'Sultry 53kg',
                horseId: ''
            },
            jockey: {
                name: 'Mjoka M',
                jockeyId: ''
            },
            weight: '51,5kg',
            time: '102,94',
            adjustedTime: '104,67',
            openingPrice: {
                numerator: '8',
                denominator: '1'
            },
            startingPrice: {
                numerator: '13',
                denominator: '1'
            },
            comment: 'Ran on well'
        },
        {
            date: '21.03.18',
            course: 'F',
            referenceAndGoing: '328G',
            race: 'JP-F',
            averageFieldRating: '61',
            equipment: 'A',
            distance: '1200m',
            meritRating: '63',
            draw: '3/12',
            position: {
                value: '1',
                raceId: ''
            },
            lengthsBehind: '1,25',
            winnerOrSecond: {
                name: 'Sultry 53kg',
                horseId: ''
            },
            jockey: {
                name: 'Mjoka M',
                jockeyId: ''
            },
            weight: '51,5kg',
            time: '102,94',
            adjustedTime: '104,67',
            openingPrice: {
                numerator: '8',
                denominator: '1'
            },
            startingPrice: {
                numerator: '13',
                denominator: '1'
            },
            comment: 'Ran on well'
        }
    ]
};